import * as React from 'react';
import classNames from 'styles/utils/classNames';

interface Props {
  label: string;
  onClick: () => void;
  isSelected: boolean;
  className?: string;
  /** Leading glyph, e.g. the activity icon on the clinic filters "Type" tabs. */
  icon?: React.ReactNode;
}

export default function FilterBox({ label, onClick, isSelected, className, icon }: Props) {
  return (
    <button
      type="button"
      className={classNames(
        'typography-product-chips-filters flex w-full items-center justify-center gap-2 rounded-md px-1 py-3 text-center',
        isSelected
          ? 'bg-color-bg-lightmode-invert text-color-text-lightmode-invert dark:bg-color-bg-darkmode-invert dark:text-color-text-darkmode-invert'
          : 'bg-color-bg-lightmode-secondary text-color-text-lightmode-secondary dark:bg-color-bg-darkmode-secondary dark:text-color-text-darkmode-secondary',
        className,
      )}
      onClick={onClick}
    >
      {icon}
      {label}
    </button>
  );
}
